import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, CreditPaymentsTable, SignPayment } from 'components';
import { showApiError } from 'utils';
import { getCreditPayments } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CreditPaymentsTab = function CreditPaymentsTab(_ref) {
  var creditId = _ref.creditId,
      onCreditChange = _ref.onCreditChange,
      creditPaymentType = _ref.creditPaymentType;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      payments = _useState2[0],
      setPayments = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      pdf = _useState4[0],
      setPdf = _useState4[1];

  useEffect(function () {
    fetchPayments();
  }, []);

  var fetchPayments = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getCreditPayme, _yield$getCreditPayme2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCreditPayments(creditId);

            case 2:
              _yield$getCreditPayme = _context.sent;
              _yield$getCreditPayme2 = _slicedToArray(_yield$getCreditPayme, 2);
              res = _yield$getCreditPayme2[0];
              err = _yield$getCreditPayme2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setPayments(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPayments() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPayments(function (prev) {
                return prev === null || prev === void 0 ? void 0 : prev.map(function (el) {
                  return (el === null || el === void 0 ? void 0 : el.id) === (data === null || data === void 0 ? void 0 : data.id) ? data : el;
                });
              });
              _isFunction(onCreditChange) && onCreditChange();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDelete(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleBack = function handleBack() {
    fetchPayments();
    setPdf();
  };

  return ___EmotionJSX(React.Fragment, null, pdf ? ___EmotionJSX(Row, {
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(SignPayment, {
    document: pdf,
    onBack: handleBack,
    onSignSuccess: function onSignSuccess(data) {
      return setPdf(data);
    },
    creditId: creditId
  }))) : ___EmotionJSX(Row, {
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref4) {
      var css = _ref4.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0412\u043D\u043E\u0441\u043A\u0438"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX(CreditPaymentsTable, {
    noTitle: true,
    payments: payments,
    creditId: creditId,
    creditPaymentType: creditPaymentType,
    onDelete: handleDelete,
    onSign: function onSign(data) {
      return setPdf({
        url: data === null || data === void 0 ? void 0 : data.url,
        paymentId: data === null || data === void 0 ? void 0 : data.paymentId,
        documentId: data === null || data === void 0 ? void 0 : data.documentId,
        isSign: false
      });
    }
  })))));
};

CreditPaymentsTab.propTypes = {
  creditId: PropTypes.number,
  onCreditChange: PropTypes.func,
  creditPaymentType: PropTypes.string
};
export default CreditPaymentsTab;